module.exports = __webpack_public_path__ + "img/fcf60d1e0b3de2da20aa673e2329793.81e8f18a.jpg";